import React from 'react';

interface HandoverDetailHeaderProps {
  title: string;
  subtitle?: string;
  onBack: () => void;
  actionButton?: React.ReactNode;
}

const HandoverDetailHeader: React.FC<HandoverDetailHeaderProps> = ({
  title,
  subtitle,
  onBack,
  actionButton,
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <button
            type="button"
            onClick={onBack}
            className="mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
            aria-label="Back"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <div>
            <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
            {subtitle ? (
              <p className="mt-0.5 text-xs text-gray-500">{subtitle}</p>
            ) : null}
          </div>
        </div>
        {actionButton ? <div className="mt-0.5">{actionButton}</div> : null}
      </div>
    </div>
  );
};

export default HandoverDetailHeader;
